
import React, { useState, useEffect } from 'react';
import { Lock, Edit2, Trash2, Search } from 'react-feather';
import { BiDrink } from "react-icons/bi";
import { GiCook } from "react-icons/gi";
import './Etiquettes.css';
import { all_routes } from '../../../Router/all_routes';
import SessionControl from '../../components/SessionControl/sessioncontrol';
import CheckRestauSelected from '../../components/SessionControl/checkrestauselected';
import axios from 'axios';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { base_api_url } from '../../../environment';
import AddEtiquette from '../../../core/modals/etiquettes/addetiquette.jsx';
import CatalogueNav from '../../components/CatalogueNav/CatalogueNav';


const EtiquettesNew = () => {
    const MySwal = withReactContent(Swal);
    const route = all_routes;
    // UI states
    const [menuOuvert, setMenuOuvert] = useState(null);
    const [etiquettes, setEtiquettes] = useState([]);
    const [reload, setReload] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [showAddEtiquetteModal, setShowAddEtiquetteModal] = useState(false);
    const [showEditEtiquetteModal, setShowEditEtiquetteModal] = useState(false);
    const [editingEtiquette, setEditingEtiquette] = useState(null);

    // --- Fonctions de chargement ---

    const fetchEtiquettes = async () => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
        try {
            const url = `${base_api_url}api/etiquette/${ideresto}`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const etiquettesData = response.data.etiquette || [];
            setEtiquettes(etiquettesData);
            if ((response.status === 200 || response.status === 201) && etiquettesData.length <= 0) {
                MySwal.fire({
                    icon: "info",
                    // title: "Aucune étiquette",
                    text: "Aucune étiquette trouvée pour ce restaurant.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: { popup: "pixel-toast" },
                });
            }
        } catch (error) {
            //             let errorTitle = "Erreur de chargement";
            let errorMessage = "Impossible de charger les étiquettes.";
            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;
                switch (status) {
                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
                        setTimeout(() => {
                            window.location.href = route.signin;
                        }, 2000);
                        break;
                    case 404:
                        //                         errorTitle = "Restaurant introuvable";
                        errorMessage = "Aucune étiquette trouvée pour ce restaurant ou le restaurant n'existe pas.";
                        break;
                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
                        break;
                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des étiquettes.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: { popup: "pixel-toast" },
            });
            setEtiquettes([]);
        } finally {
            setLoading(false);
        }
    };

    // --- Hooks ---

    useEffect(() => {
        fetchEtiquettes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload]);

    // Filtrage par recherche
    const filteredData = etiquettes.filter(e => {
        const nom = (e.nom || "").toLowerCase();
        const code = (e.code || "").toLowerCase();
        const tag = (e.tag || "").toLowerCase();
        const term = searchTerm.toLowerCase();
        return nom.includes(term) || code.includes(term) || tag.includes(term);
    });

    // Séparation système/personnalisées
    // Les étiquettes système sont : celles avec estSysteme=true OU dont le code est "cuisine" ou "bar"
    const etiquettesSysteme = filteredData.filter(e => {
        const isSystemByFlag = e.estSysteme === true;
        const isSystemByName = e.code?.toLowerCase() === 'cuisine' || e.code?.toLowerCase() === 'bar';
        return isSystemByFlag || isSystemByName;
    });

    const etiquettesPersonnalisees = filteredData.filter(e => {
        const isSystemByFlag = e.estSysteme === true;
        const isSystemByName = e.code?.toLowerCase() === 'cuisine' || e.code?.toLowerCase() === 'bar';
        return !isSystemByFlag && !isSystemByName;
    });

    // Effect on modal to trigger reload
    const effectOnModal = () => {
        setReload(!reload);
    };

    // Gestion modals
    const handleAddEtiquetteClick = () => {
        setShowAddEtiquetteModal(true);
        setShowEditEtiquetteModal(false);
    };

    const handleEditEtiquette = (etiquette) => {
        console.log("Editing etiquette:", etiquette);
        setEditingEtiquette(etiquette);
        setShowEditEtiquetteModal(true);
        setShowAddEtiquetteModal(false);
    };

    // Fonction pour supprimer une étiquette
    const handleDeleteEtiquette = async (etiquette) => {
        const result = await MySwal.fire({
            title: 'Êtes-vous sûr ?',
            text: `Voulez-vous vraiment supprimer l'étiquette "${etiquette.nom || etiquette.code}" ? Cette action est irréversible !`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6a3d',
            cancelButtonColor: '#94a3b8',
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
            customClass: { popup: "pixel-toast-delete" }
        });

        if (result.isConfirmed) {
            setLoading(true);
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;
            try {
                await axios.put(`${base_api_url}api/etiquette/${etiquette.id_etiquette || etiquette.id}`, 
                    { status: 0 }, 
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                MySwal.fire({
                    icon: "success",
                    text: "Étiquette supprimée avec succès.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: { popup: "pixel-toast" },
                });

                setReload(!reload);
            } catch (error) {
                console.error("Erreur lors de la suppression:", error);
                MySwal.fire({
                    icon: "error",
                    text: "Une erreur est survenue lors de la suppression.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: { popup: "pixel-toast" },
                });
            } finally {
                setLoading(false);
            }
        }
    };

    // Fonction pour basculer le statut
    /* const handleToggleStatus = async (etiquette) => {
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        const currentStatus = etiquette.statut || 'Active';
        const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';

        try {
            await axios.put(`${base_api_url}api/etiquette/${etiquette.id_etiquette || etiquette.id}`, 
                { ...etiquette, statut: newStatus, code: etiquette.code || etiquette.nom }, 
                { headers: { Authorization: `Bearer ${token}` } }
            );

            MySwal.fire({
                icon: "success",
                text: `Étiquette ${newStatus === 'Active' ? 'activée' : 'désactivée'} avec succès.`,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                customClass: { popup: "pixel-toast" },
            });

            setReload(!reload);
        } catch (error) {
            console.error("Erreur status:", error);
        }
    }; */

    // Fonction pour mettre à jour une étiquette
    const handleUpdateEtiquette = async () => {
        try {
            console.log("Etiquette updated successfully");

            // Fermer le modal après update
            setShowEditEtiquetteModal(false);
            setEditingEtiquette(null);

            // Refresh the etiquettes list
            setReload(!reload);

        } catch (error) {
            console.error("Erreur lors de la mise à jour de l'étiquette:", error);
            MySwal.fire({
                icon: "error",
                // title: "Erreur lors de la mise à jour",
                text: "Veuillez réessayer.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        }
    };




    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuOuvert && !event.target.closest('.actions-dropdown')) {
                setMenuOuvert(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOuvert]);

    return (
        <div className="page-wrapper">
            <SessionControl storageKey="user" propsup="email" redirectTo={route.signin} />
            <CheckRestauSelected storageKey="user" redirectTo={route.Restaurants} />
            <div className="etiquettes-page">
                {/* NAVIGATION CATALOGUE */}
                <CatalogueNav
                    activeTabId="etiquettes"
                    subtitle="Gestion des étiquettes."
                    addButtonText="Ajouter une étiquette"
                    onAddClick={handleAddEtiquetteClick}
                />


                {/* Barre de recherche */}
                <div style={{ marginBottom: 24, padding: "0 24px" }}>
                    <div style={{ position: 'relative', maxWidth: '320px' }}>
                        <Search size={18} style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                        <input
                            type="text"
                            placeholder="Rechercher une étiquette..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px 16px 12px 42px',
                                border: '1px solid #e2e8f0',
                                borderRadius: '8px',
                                fontSize: '14px',
                                outline: 'none'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#cbd5e1'}
                            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                        />
                    </div>
                </div>

                {/* ÉTIQUETTES SYSTÈME */}
                <h3 className="section-title">Étiquettes Système</h3>
                <div className="etiquettes-list">
                    {loading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Chargement...</span>
                            </div>
                        </div>
                    ) : etiquettesSysteme.length === 0 ? (
                        <div className="text-center text-muted py-4">Aucune étiquette système trouvée.</div>
                    ) : etiquettesSysteme.map((etiquette) => (
                        <div key={etiquette.id_etiquette || etiquette.id} className="etiquette-card">
                            <div className="etiquette-left">
                                <div className={`etiquette-icon-box ${etiquette.classeIcone || 'icon-bar'}`}>
                                    {etiquette.icone || <BiDrink size={20} />}
                                </div>
                                <div className="etiquette-info">
                                    <span className="etiquette-name">{etiquette.nom || etiquette.code}</span>
                                    {etiquette.estSysteme && <Lock size={13} className="icon-lock" />}
                                </div>
                            </div>
                            <div className="etiquette-right">
                                <div className={`tag-label ${etiquette.classeTag || 'tag-purple'}`}>
                                    {etiquette.tag || etiquette.nom || etiquette.code}
                                </div>
                                <span className="plat-count">{etiquette.plats || 0} plat</span>
                                <div className="status-active">{etiquette.statut || 'Active'}</div>
                                {/* Actions directes */}
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: '16px' }}>
                                    <button
                                        className="btn-actions"
                                        title="Modifier"
                                        onClick={() => handleEditEtiquette(etiquette)}
                                    >
                                        <Edit2 size={16} />
                                    </button>
                                    {/* <button
                                        className="btn-actions"
                                        title={etiquette.statut === 'Inactive' ? "Activer" : "Désactiver"}
                                        onClick={() => handleToggleStatus(etiquette)}
                                    >
                                        {etiquette.statut === 'Inactive' ? <EyeOff size={16} /> : <Eye size={16} />}
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* ÉTIQUETTES PERSONNALISÉES */}
                <h3 className="section-title">Étiquettes Personnalisées</h3>
                <div className="etiquettes-list">
                    {loading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Chargement...</span>
                            </div>
                        </div>
                    ) : etiquettesPersonnalisees.length === 0 ? (
                        <div className="text-center text-muted py-4">Aucune étiquette personnalisée trouvée.</div>
                    ) : etiquettesPersonnalisees.map((etiquette) => (
                        <div key={etiquette.id_etiquette || etiquette.id} className="etiquette-card">
                            <div className="etiquette-left">
                                <div className={`etiquette-icon-box ${etiquette.classeIcone || 'icon-cuisine'}`}>
                                    {etiquette.icone || <GiCook size={20} />}
                                </div>
                                <div className="etiquette-info">
                                    <span className="etiquette-name">{etiquette.nom || etiquette.code}</span>
                                </div>
                            </div>
                            <div className="etiquette-right">
                                <div className={`tag-label ${etiquette.classeTag || 'tag-orange'}`}>
                                    {etiquette.tag || etiquette.nom || etiquette.code}
                                </div>
                                <span className="plat-count">{etiquette.plats || 0} plat</span>
                                <div className="status-active">{etiquette.statut || 'Active'}</div>
                                {/* Actions directes */}
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: '16px' }}>
                                    <button
                                        className="btn-actions"
                                        title="Modifier"
                                        onClick={() => handleEditEtiquette(etiquette)}
                                    >
                                        <Edit2 size={16} />
                                    </button>
                                    {/* <button
                                        className="btn-actions"
                                        title={etiquette.statut === 'Inactive' ? "Activer" : "Désactiver"}
                                        onClick={() => handleToggleStatus(etiquette)}
                                    >
                                        {etiquette.statut === 'Inactive' ? <EyeOff size={16} /> : <Eye size={16} />}
                                    </button> */}
                                    <button
                                        className="btn-actions delete"
                                        title="Supprimer"
                                        style={{ color: '#ef4444' }}
                                        onClick={() => handleDeleteEtiquette(etiquette)}
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* MODALS */}
                {showAddEtiquetteModal && (
                    <AddEtiquette
                        show={showAddEtiquetteModal}
                        onFormSubmit={() => {
                            effectOnModal();
                            setShowAddEtiquetteModal(false);
                        }}
                        onClose={() => setShowAddEtiquetteModal(false)}
                    />
                )}

                {/* Edit Etiquettes Modal */}
                {showEditEtiquetteModal && editingEtiquette && (
                    <AddEtiquette
                        show={showEditEtiquetteModal}
                        editMode={true}
                        etiquetteData={editingEtiquette}
                        onFormSubmit={() => {
                            handleUpdateEtiquette();
                            effectOnModal();
                        }}
                        onClose={() => {
                            setShowEditEtiquetteModal(false);
                            setEditingEtiquette(null);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default EtiquettesNew;
